<template>
  <div class="fab" @click="click">
    <b-icon-plus class="fab-icon" />
  </div>
</template>
<style scoped>
.fab {
  position: fixed;
  cursor: pointer;
  right: 5vw;
  bottom: 4vh;
  z-index: 999;
  background-color: #00b7c6;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  box-shadow:
    0 10px 10px rgb(0 0 0 / 20%),
    0 4px 4px rgb(0 0 0 / 15%);
}
.fab-icon {
  color: white;
  width: 40px;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
</style>
<script lang="ts">
import { defineComponent, getCurrentInstance } from "vue";
import type Vue from "vue";
export default defineComponent({
  name: "fab",
  props: {
    to: { type: String, required: false },
  },
  setup(props, { emit }) {
    // vue-router 3.5 には useRouter が無いため $router をインスタンス経由で取得
    const vm = getCurrentInstance()?.proxy as Vue | undefined;

    const click = (): void => {
      if (props.to) {
        const router = vm?.$router;
        if (router) {
          router.push(props.to);
        }
      } else {
        emit("fab-clicked");
      }
    };

    return { click };
  },
});
</script>
